import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useUser } from "../../context/UserContext";
import { getMyActivity } from "../../lib/api";
import ActivityTimeline from "../common/ActivityTimeline";

export default function PortalActivity() {
  const { token } = useUser();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    getMyActivity(token)
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="space-y-4" data-testid="portal-activity-page">
      <div>
        <h1 className="font-serif text-2xl font-bold text-navy">My Activity</h1>
        <p className="text-gray-500 text-sm mt-0.5">
          A timeline of your account activity — payments, documents, appointments and messages.
        </p>
      </div>
      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-6 w-6 animate-spin text-navy" />
          </div>
        ) : (
          <ActivityTimeline items={items} emptyText="No activity recorded yet." />
        )}
      </div>
    </div>
  );
}
